module.exports = __webpack_public_path__ + "img/branch-icon.f1c10c33.svg";